// extracted by mini-css-extract-plugin
export default {"table_header":"Table_table_header__zyl7r","table__wrapper":"Table_table__wrapper__AQth4"};